import { render, staticRenderFns } from "./education_card.vue?vue&type=template&id=3ef0d070&scoped=true"
import script from "./education_card.vue?vue&type=script&lang=js"
export * from "./education_card.vue?vue&type=script&lang=js"
import style0 from "./education_card.vue?vue&type=style&index=0&id=3ef0d070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef0d070",
  null
  
)

export default component.exports